export default __webpack_public_path__ + "static/1-99dfc71395700a093b7ccf1f1e2b39e9.png";